import * as React from 'react';
import * as ReactDOM from 'react-dom';
import LeadsGenerator from './components/LeadsGenerator';
import './styles/app.scss';

declare global {
  // tslint:disable-next-line
  interface Window {
    leadsGenerator2: {
      init: (container: HTMLElement) => void;
    };
  }
}

window.leadsGenerator2 = {
  init: (container: HTMLElement) => {
    ReactDOM.render(<LeadsGenerator />, container);
  },
};
